import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const RouteSwitcher = ({ routes }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const activeIndex = routes.findIndex((route) =>
    location.pathname.startsWith(route.path),
  );

  return (
    <div className="relative w-full">
      {/* Button container */}
      <div className="flex flex-col space-y-1 rounded-lg bg-gray-200 p-2 sm:flex-row sm:space-x-1 sm:space-y-0">
        {routes.map((route, index) => (
          <button
            key={route.path}
            className={`flex-1 rounded-lg p-2 text-center text-sm font-medium transition-all duration-200 sm:p-3 sm:text-base ${
              activeIndex === index
                ? "bg-blue-500 text-white shadow-md"
                : "bg-gray-300 text-gray-700 hover:bg-gray-400"
            }`}
            onClick={() => navigate(route.path)}
          >
            <span className="block truncate">{route.name}</span>
          </button>
        ))}
      </div>

      <div className="mt-4 sm:mt-6">
        <Outlet />
      </div>
    </div>
  );
};

export default RouteSwitcher;
